import './styles.scss';

import { mdiInformation } from '@mdi/js';
import { Tooltip } from 'antd';
import Icon from 'components/Icon/Icon';
import React from 'react';

export const SELECT_RENDER_LIMIT = 3;

export const renderErrorMessage = (showError: boolean, error?: string) =>
  showError ? <span className="invalid-feedback">{error}</span> : <span />;

export const renderLabel = (label?: string, required?: boolean) => {
  if (label) {
    return (
      <label className="form-label">
        {label}
        {required && <span className="required-asterisk">*</span>}
      </label>
    );
  }

  return null;
};

export const getHookGroupClass = (label?: string, aditionalClassNames?: string) =>
  `hook-form-group${!label ? ' no-label' : ''} ${aditionalClassNames || ''}`;

export const getHookFieldClass = (touched: boolean, invalid: boolean) => {
  if (invalid) return 'form-control is-invalid'; // Check if we are OK with handling only based on invalid.
  if (touched && !invalid) return 'form-control is-valid';
  return 'form-control';
};

export const renderHookLabel = (fieldName: string, label?: string, required?: boolean) => {
  if (label) {
    return (
      <label className="hook-form-label" htmlFor={fieldName}>
        {label}
        {required && <span className="required-asterisk">*</span>}
      </label>
    );
  }

  return null;
};

export interface InputNoteConfig {
  value: React.ReactNode;
  mode: 'inline' | 'tooltip';
}

export const renderHookInputNote = (note?: InputNoteConfig) => {
  if (note?.mode === 'tooltip') {
    return (
      <Tooltip
        title={note.value}
        classNames={{ root: 'hook-form-inputNote-tooltip' }}
        className="hook-form-note-tooltip"
      >
        <div className="hook-form-note-tooltip-icon">
          <Icon path={mdiInformation} />
        </div>
      </Tooltip>
    );
  }

  if (note) {
    return <span className="hook-form-note">{note.value}</span>;
  }

  return null;
};

export const renderHookInputHeader = (
  fieldName: string,
  label?: string,
  required?: boolean,
  inputNote?: InputNoteConfig
) => (
  <div
    className={`hook-form-header${!label ? ' no-label' : ''}${!inputNote ? ' no-inputNote' : ''}${
      inputNote?.mode === 'tooltip' ? ' with-tooltip' : ''
    }
    `}
  >
    {renderHookLabel(fieldName, label, required)}
    {renderHookInputNote(inputNote)}
  </div>
);

export const inputNameWithPrefx = (name: string, prefix?: string) => {
  if (prefix) return `${prefix}.${name}`;
  return name;
};
